(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-blogs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-blogs')) {
  customElements.define('sl-blogs', class SlBlogs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sl-blogs__track');
      this.buttons = Array.from(this.querySelectorAll('.sl-blogs__btn'));
      if (!this.track) return;
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const card = this.track.querySelector('.sl-post');
          const step = card ? card.getBoundingClientRect().width + 20 : this.track.clientWidth * 0.8;
          this.track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
        });
      });
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 4;
        if (this.buttons[0]) this.buttons[0].disabled = this.track.scrollLeft <= 4;
        if (this.buttons[1]) this.buttons[1].disabled = this.track.scrollLeft >= max;
      };
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }
    disconnectedCallback() { window.removeEventListener('resize', this.update); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-hero')) {
  customElements.define('sl-hero', class SlHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.sl-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.sl-hero__dot'));
      this.index = 0;
      this.slides.forEach((slide, i) => { slide.inert = i !== 0; });
      if (this.slides.length < 2) return;

      this.delay = (parseInt(this.dataset.speed, 10) || 6) * 1000;
      this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.paused = false;
      this.slidesEl = this.querySelector('.sl-hero__slides');

      // Pause / play button (only matters while the slides rotate by themselves)
      this.toggle = this.querySelector('.sl-hero__toggle');
      if (this.toggle) {
        if (!this.autoplay) {
          this.toggle.hidden = true;
        } else {
          this.toggle.addEventListener('click', () => {
            this.paused = !this.paused;
            this.toggle.classList.toggle('is-paused', this.paused);
            this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
            if (this.paused) this.stop(); else this.start();
          });
        }
      }
      // Screen readers announce slide changes only when the visitor changes slides, not while they rotate
      if (this.slidesEl) this.slidesEl.setAttribute('aria-live', this.autoplay ? 'off' : 'polite');

      this.querySelectorAll('.sl-hero__arrow[data-dir]').forEach((button) => {
        button.addEventListener('click', () => { this.go(this.index + Number(button.dataset.dir)); this.restart(); });
      });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      // Swipe / drag
      this.startX = null;
      this.addEventListener('pointerdown', (event) => { this.startX = event.clientX; this.swiped = false; });
      this.addEventListener('pointerup', (event) => {
        if (this.startX === null) return;
        const dx = event.clientX - this.startX;
        this.startX = null;
        if (Math.abs(dx) > 50) {
          this.swiped = true;
          this.go(this.index + (dx < 0 ? 1 : -1));
          this.restart();
        }
      });
      this.addEventListener('click', (event) => {
        if (this.swiped) { event.preventDefault(); this.swiped = false; }
      }, true);

      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);

      // Preload the other slides' images once the page has loaded, so they never appear empty
      const preload = () => this.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      if (document.readyState === 'complete') preload();
      else window.addEventListener('load', preload, { once: true });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    go(target) {
      const count = this.slides.length;
      const next = (target + count) % count;
      if (next === this.index) return;
      const current = this.slides[this.index];
      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      current.inert = true;
      const incoming = this.slides[next];
      incoming.classList.add('is-active');
      incoming.removeAttribute('aria-hidden');
      incoming.inert = false;
      this.dots.forEach((dot, i) => {
        if (i === next) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.index = next;
    }

    start() {
      if (!this.autoplay || this.paused) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      if (this.slidesEl) this.slidesEl.setAttribute('aria-live', 'off');
    }

    stop() {
      clearInterval(this.timer);
      if (this.slidesEl) this.slidesEl.setAttribute('aria-live', 'polite');
    }

    restart() { this.stop(); this.start(); }
  });

  // Theme editor: show the slide that is being edited
  document.addEventListener('shopify:block:select', (event) => {
    const hero = event.target.closest && event.target.closest('sl-hero');
    if (!hero || !hero.slides) return;
    const i = hero.slides.indexOf(event.target);
    if (i > -1) { hero.stop(); hero.go(i); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-instagram"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-insta')) {
  customElements.define('sl-insta', class SlInsta extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sl-insta__track');
      if (!this.track) return;

      this.querySelectorAll('.sl-insta__nav button').forEach((button) => {
        button.addEventListener('click', () => {
          const card = this.track.querySelector('.sl-reel');
          const step = card ? card.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
          this.track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
        });
      });

      // Play any videos silently while they are on screen, pause them when they are not
      const videos = this.track.querySelectorAll('video');
      if (!videos.length) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      videos.forEach((video) => { video.muted = true; video.setAttribute('playsinline', ''); });
      if (reduce || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) { const p = video.play(); if (p && p.catch) p.catch(() => {}); }
          else video.pause();
        });
      }, { threshold: 0.5 });
      videos.forEach((video) => this.observer.observe(video));
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-promo-popup"]) return;
  try {
    
if (!customElements.get('sl-promo-popup')) {
  customElements.define('sl-promo-popup', class SlPromoPopup extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.key || 'sl-promo';
      this.card = this.querySelector('.sl-promo__card');
      const days = parseFloat(this.dataset.days || '3');
      const delay = parseFloat(this.dataset.delay || '3') * 1000;
      this.onKey = (event) => {
        if (event.key === 'Escape' || event.key === 'Esc') { event.preventDefault(); this.close(); return; }
        if (event.key === 'Tab') this.keepFocus(event);
      };
      // Modal dialog: if focus ever ends up behind it (screen reader, another script), bring it back inside
      this.onFocusIn = (event) => {
        if (!this.card || this.card.contains(event.target)) return;
        const items = this.focusables();
        if (items.length) items[0].focus({ preventScroll: true });
      };
      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      const copyBtn = this.querySelector('[data-copy]');
      if (copyBtn) copyBtn.addEventListener('click', () => this.copy(copyBtn));
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => { if (event.target.contains(this)) this.open(); });
        document.addEventListener('shopify:section:deselect', (event) => { if (event.target.contains(this)) this.close(true); });
        return;
      }
      let last = 0;
      try { last = parseInt(localStorage.getItem(this.key) || '0', 10); } catch (e) {}
      if (last && Date.now() - last < days * 86400000) return;
      // Don't pop up in the middle of typing (search, forms) or over an open menu, search or cart:
      // wait a little and try again (at most ~30 s extra, then show it anyway)
      let retries = 0;
      const tryOpen = () => {
        if (this.isBusy() && retries < 15) { retries += 1; this.timer = setTimeout(tryOpen, 2000); return; }
        this.open();
      };
      this.timer = setTimeout(tryOpen, delay);
    }
    isBusy() {
      const el = document.activeElement;
      const typing = !!el && (el.isContentEditable || el.tagName === 'TEXTAREA'
        || (el.tagName === 'INPUT' && /^(text|search|email|tel|number|password|url|)$/i.test(el.getAttribute('type') || '')));
      const body = document.body.classList;
      return typing || body.contains('overflow-hidden') || body.contains('overflow-hidden-mobile') || body.contains('overflow-hidden-tablet')
        || !!document.querySelector('cart-drawer.active, cart-notification .active');
    }
    focusables() {
      if (!this.card) return [];
      return Array.from(this.card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'))
        .filter((el) => el.getClientRects().length > 0);
    }
    // Keep Tab / Shift+Tab cycling inside the pop-up while it is open
    keepFocus(event) {
      const items = this.focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      const inside = this.card.contains(active);
      if (event.shiftKey && (active === first || !inside)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (active === last || !inside)) { event.preventDefault(); first.focus(); }
    }
    open() {
      if (!this.hidden) return;
      const active = document.activeElement;
      this.returnFocus = active && active !== document.body && !this.contains(active) ? active : null;
      this.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('focusin', this.onFocusIn);
      const closeBtn = this.querySelector('.sl-promo__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    close(skipSave) {
      clearTimeout(this.timer);
      const focusWasInside = this.contains(document.activeElement);
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('focusin', this.onFocusIn);
      if (!skipSave) { try { localStorage.setItem(this.key, String(Date.now())); } catch (e) {} }
      setTimeout(() => { this.hidden = true; }, 300);
      // Give keyboard focus back to whatever the visitor was on before the pop-up appeared
      const back = this.returnFocus;
      this.returnFocus = null;
      if (focusWasInside) {
        if (back && back.isConnected) back.focus({ preventScroll: true });
        else document.activeElement.blur();
      }
    }
    copy(btn) {
      const code = btn.dataset.copy;
      const label = btn.textContent;
      const status = this.querySelector('[data-copy-status]');
      const done = () => {
        btn.textContent = btn.dataset.copied;
        btn.classList.add('is-copied');
        // Screen readers hear "Copied" too
        if (status) status.textContent = btn.dataset.copied;
        setTimeout(() => {
          btn.textContent = label;
          btn.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 2000);
      };
      const fallback = () => {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.setAttribute('aria-hidden', 'true');
        ta.tabIndex = -1;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        // Inside the dialog, so the focus guard above doesn't pull focus away mid-copy
        (this.card || document.body).appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        ta.remove();
        btn.focus({ preventScroll: true });
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else {
        fallback();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
